/**
 * Created by vladislav on 9/6/2022
 */

const OKPlatform = function () {
    this.listeners = {};

    Platform.call(this, connector.OK, {
        sdk: SdkManager.SDK_OK
    });

    const params = connector.utils.getRequestParameters();

    if (["androidweb", "iosweb", "mobweb", "android", "ios"].includes(params.mob_platform)) {
        connector.info.isMobile = true;
    }

    if (["android", "ios"].includes(params.mob_platform)) {
        connector.info.isInApp = true;
    }

    if (params.mob_platform === "android") {
        connector.info.os = connector.OS_ANDROID;
    }

    if (params.mob_platform === "ios") {
        connector.info.os = connector.OS_IOS;
    }
};

OKPlatform.prototype = Object.create(Platform.prototype);
OKPlatform.prototype.constructor = OKPlatform;

OKPlatform.prototype.getLocalStoragePrefix = function () {
    return "_OK";
};

OKPlatform.prototype._connect = function (callback) {
    this.listeners = {};

    if (connector.info.isInApp && connector.info.os === connector.OS_ANDROID) {
        this.initPushNotifications();
    }

    callback(connector.STATUS_CONNECTED);
};

OKPlatform.prototype._loadDataKeys = function () {
    return new Promise((resolve, reject) => {
        FAPI.Client.call({
            method: "storage.getKeys",
            scope: "CUSTOM",
            count: 1000
        }, (code, data, error) => {
            if (code === "ok") {
                resolve(data.keys);
            } else {
                reject(error);
            }
        });
    });
};

OKPlatform.prototype.loadData = function () {
    return this._loadDataKeys().then((keys) => new Promise((resolve, reject) => {
        if (keys.length === 0) {
            resolve({});
            return;
        }

        FAPI.Client.call({
            method: "storage.get",
            scope: "CUSTOM",
            keys
        }, (code, data, error) => {
            if (code === "ok") {
                const res = {};

                for (const key in data.data) {
                    let currentData = data.data[key];

                    try {
                        const obj = JSON.parse(currentData);
                        if (typeof obj === "object") {
                            currentData = obj;
                        }
                    } catch (e) { /* empty */ }

                    res[key] = currentData;
                }

                resolve(res);
            } else {
                reject(error);
            }
        });
    }));
};

OKPlatform.prototype.setData = function (key, data) {
    return new Promise((resolve, reject) => {
        FAPI.Client.call({
            method: "storage.set",
            key,
            value: typeof data === "object" ? JSON.stringify(data) : `${data}`
        }, (code, data, error) => {
            if (code === "ok") {
                resolve(true);
            } else {
                reject(error);
            }
        });
    });
};

OKPlatform.prototype._parsePayload = function (callback) {
    const params = connector.utils.getRequestParameters();
    if (params.custom_args) {
        let customArgs = "";
        try {
            customArgs = decodeURIComponent(params.custom_args);
            Object.assign(params, connector.utils.getRequestParameters(`?${customArgs}`));
        } catch (e) {
            this.bus.trigger("stream:error", `calcChannel decodeURIComponent error, params.custom_args - ${params.custom_args}`);
        }
    }
    callback(params);
};

OKPlatform.prototype.parseOtherWays = function (callback) {
    this.parsePayload((params) => {
        const refplace = (params.refplace || "").toLowerCase();
        const filter = ["rb_17", "promo_shop", "recommended_apps", "game_campaign_portlet", "game_campaign", "vitrine_video", "eventcard", "eventpush"];
        const entryPoint = filter.includes(refplace) || refplace.startsWith("exp_group_")
            ? refplace : undefined;
        callback(entryPoint);
    });
};

OKPlatform.prototype.onSdkEvent = function (method, result, data) {
    if (this.listeners[method]) {
        const listener = this.listeners[method];
        this.listeners[method] = undefined;
        listener.call(this, result, data);
    }
};

// OK forwards the "custom_args" search param of a game link into the opened app's launch params, where
// _parsePayload unpacks it as a query string; a switchGame payload with a crossId or promo travels there with the channel.
// Stand check: a crossId link from one OK game must open the other with connector.utils.getRequestParameters()
// holding custom_args, on the web and in the OK mobile apps, where the link opens through the native shell.
OKPlatform.prototype.canPassPayload = function () {
    return true;
};

OKPlatform.prototype.switchGame = function (url, payload) {
    if (url && payload && (payload.crossId || payload.promo)) {
        const args = {};
        const channel = payload.channel || new URL(url).searchParams.get("channel");
        if (channel) {
            args.channel = channel;
        }

        Platform.CROSSPROMO_PAYLOAD_FIELDS.forEach((key) => {
            if (payload[key] !== undefined) {
                args[key] = payload[key];
            }
        });

        url = connector.utils.addSearchParams(url, {
            custom_args: new URLSearchParams(args).toString()
        });

        // a VK game in OK (bridge) gets no custom_args, only the fragment, read as VK's "channel|crossId|<the other fields>"
        const extra = new URLSearchParams(args);
        extra.delete("channel");
        extra.delete("crossId");
        const hash = [channel || "", payload.crossId || "", extra.toString()].join("|");
        url += `#${encodeURIComponent(hash)}`;
    }

    Platform.prototype.switchGame.call(this, url);
};

OKPlatform.prototype.openUrl = function (url) {
    const link = document.createElement("a");
    link.setAttribute("target", "_blank");
    link.setAttribute("href", url);
    link.click();
};

OKPlatform.prototype.initPushNotifications = function () {
    this.listeners.getPushNotificationsStatus = function (code, data) {
        if (code !== "ok") {
            return;
        }

        data = JSON.parse(data);

        if (data.isGlobalEnabled === "true" && data.isSubscriptionEnabled === "true") {
            this.savePushPermission(true);
        } else {
            FAPI.UI.suggestToEnablePushNotifications();
        }
    }.bind(this);

    this.listeners.suggestToEnablePushNotifications = function (code) {
        this.savePushPermission(code === "ok");
    }.bind(this);

    FAPI.UI.getPushNotificationsStatus();
};

OKPlatform.prototype.savePushPermission = function (permission) {
    if (!connector.platform.getUserID() || connector.platform.withTmpID()) {
        this.bus.once("userIdChanged", this.savePushPermission.bind(this, permission));
        return;
    }

    const userId = encodeURIComponent(connector.platform.getUserID());
    const path = `${connector.config.notificationsApiURL}/${connector.config.projectId}/permissions/${userId}`;

    ConnectorRestClient.post(path, { permission }, () => {}, () => {
        console.log("Failed to save push permission", permission);
    });
};

OKPlatform.prototype._canCreateShortcut = function () {
    return connector.info.isInApp && connector.info.os === connector.OS_ANDROID && !connector.dataLoader.load(SimpleDataLoader.TYPES.SHORTCUT_CREATED);
};

OKPlatform.prototype.createShortcut = function (callback) {
    this.listeners.requestDesktopIcon = connector.utils.once((result) => {
        const code = result === "ok" ? connector.CODE_SUCCEED : connector.CODE_FAILED;

        if (callback) {
            callback(code);
        }

        if (code === connector.CODE_SUCCEED) {
            connector.dataLoader.save(SimpleDataLoader.TYPES.SHORTCUT_CREATED, 1);
        }
    });

    FAPI.invokeUIMethod("requestDesktopIcon");
};

OKPlatform.prototype.canReview = function () {
    return true;
};

OKPlatform.prototype._requestReview = function (callback) {
    this.listeners.showRatingDialog = connector.utils.once((result, data) => {
        console.log("showRatingDialog", result, data);

        callback(result === "ok" ? connector.CODE_SUCCEED : connector.CODE_FAILED);
    });

    FAPI.UI.showRatingDialog();
};

OKPlatform.prototype.canSwitchGame = function () {
    return true;
};
